import React from 'react';
import classNames from 'classnames';
import Loading from '../loading/Loading';

interface DeleteButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onClick, isLoading }) => {
  return (
    <button type="button" className="btn btn--danger btn--curved f-right" onClick={onClick}>
      {isLoading && <Loading />}
      <span className={classNames({ invisible: isLoading })}>Delete</span>
    </button>
  );
};

export default DeleteButton;
